import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "serp__filters-list--container",
  class: "serp__filters-list--container q-container-xl q-p-3 q-p-md-2 q-bg-light q-pb-0"
}

import { computed, inject, ref, watch, unref } from 'vue'
import FilterItemContainer from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItemContainer.vue";
import UsedFilterContainer from "@/components/SerpPage/FiltersContainer/UsedFilterContainer.vue";
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import { CustomSmartSearchLabels, SmartSearchTranslationsInterface } from '@/core/types'
import { resolveCustomSmartSearchConfig } from '@/core/customSmartSearchConfig'


export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersListContainer',
  setup(__props) {

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {getFilters} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)

const SmartSearchTranslations = inject('SmartSearchTranslations') as any
const customLabels = (typeof window !== 'undefined'
  ? (window as any)?._QONizer?.customSmartSearchConfig?.labels
  : undefined) as CustomSmartSearchLabels | undefined
const { accordionVisibleItemsLimit } = resolveCustomSmartSearchConfig()
const showAllFilters = ref(false)

const checkboxFiltersCount = computed(() => {
  return getFilters.value.reduce((count, filter) => {
    return filter.type === 'checkbox' ? count + 1 : count
  }, 0)
})

const shouldDisplayToggleButton = computed(() => {
  return accordionVisibleItemsLimit > 0 && checkboxFiltersCount.value > accordionVisibleItemsLimit
})

const displayedFilters = computed(() => {
  if (!shouldDisplayToggleButton.value || showAllFilters.value) {
    return getFilters.value
  }

  let includedCheckboxes = 0

  return getFilters.value.filter((filter) => {
    if (filter.type !== 'checkbox') {
      return true
    }

    if (includedCheckboxes < accordionVisibleItemsLimit) {
      includedCheckboxes += 1
      return true
    }

    return false
  })
})

watch(shouldDisplayToggleButton, (enabled) => {
  if (!enabled) {
    showAllFilters.value = false
  }
})

const normalizeLabel = (label: unknown): string | undefined => {
  if (typeof label !== 'string') {
    return undefined
  }

  const trimmed = label.trim()
  return trimmed || undefined
}

function getShowAllFiltersLabel(): string {
  const customLabel = normalizeLabel(customLabels?.filters?.showAllFilters)
  if (customLabel) {
    return customLabel
  }

  const label = normalizeLabel(unref(SmartSearchTranslations)?.filters?.showAllFilters)
  return label || 'Pokaż wszystkie filtry'
}

function getHideFiltersLabel(): string {
  const customLabel = normalizeLabel(customLabels?.filters?.hideFilters)
  if (customLabel) {
    return customLabel
  }

  const label = normalizeLabel(unref(SmartSearchTranslations)?.filters?.hideFilters)
  return label || 'Ukryj filtry'
}

const toggleButtonLabel = computed(() => showAllFilters.value ? getHideFiltersLabel() : getShowAllFiltersLabel())

function toggleFiltersVisibility() {
  showAllFilters.value = !showAllFilters.value
}


return (_ctx: any,_cache: any) => {
  return (!_unref(noResultsState))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UsedFilterContainer),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedFilters.value, (filter, index) => {
          return (_openBlock(), _createBlock(FilterItemContainer, {
            key: filter.field,
            filter: filter,
            "filter-collapsed": _unref(isMobileView) ? index >= 1 : index >= 3
          }, null, 8, ["filter", "filter-collapsed"]))
        }), 128)),
        (shouldDisplayToggleButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "serp__filters-toggle-button",
              onClick: toggleFiltersVisibility
            }, _toDisplayString(toggleButtonLabel.value), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})